var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-dropdown',{attrs:{"required":false,"options":_vm.mappedElectricboxes,"value":_vm.activeElectricalBox},on:{"change":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }